import { Popover } from 'app/gamma/src/components/popover';
import React, { FunctionComponent } from 'react';
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { AtlassianAppSwitcher } from 'app/src/components/AtlassianAppSwitcher';

const POPOVER_TOP_OFFSET = 38;
interface AtlassianAppSwitcherPopoverProps {
  target: () => HTMLElement | null;
}

export const AtlassianAppSwitcherPopover: FunctionComponent<AtlassianAppSwitcherPopoverProps> = ({
  target,
}) => (
  <Popover
    name={HeaderTestIds.AtlassianAppSwitcher}
    offsetTop={POPOVER_TOP_OFFSET}
    target={target}
    title="More from Atlassian"
    testId={HeaderTestIds.AtlassianAppSwitcher}
  >
    {() => <AtlassianAppSwitcher />}
  </Popover>
);
